(function(global){
  'use strict';
  var prefix='/apps/rewards/';
  function signIn(){location.href='/customer_authentication/login?return_to='+encodeURIComponent(location.pathname+location.search+location.hash);}
  async function request(path,body){
    var r=await fetch(prefix+'api/designs'+path,{method:body?'POST':'GET',credentials:'same-origin',cache:'no-store',
      headers:{accept:'application/json',...(body?{'content-type':'application/json'}:{})},...(body?{body:JSON.stringify(body)}:{})});
    if(r.status===401){signIn();throw new Error('Sign in to open your design.');}
    var data=await r.json();if(!r.ok)throw new Error(data.error||'Your design could not be loaded.');return data;
  }
  async function load(productId){
    var id=new URLSearchParams(location.search).get('design');if(!id)return null;
    if(!/^[a-f0-9]{64}$/.test(id))throw new Error('Invalid design link.');
    var data=await request('/'+id+'/edit'),design=data.design;
    if(String(design.product_id)!==String(productId))throw new Error('This design belongs to a different product. Open it from Your designs.');
    var r=await fetch(design.artwork_url,{credentials:'omit',referrerPolicy:'no-referrer'});
    if(!r.ok)throw new Error('The original artwork is unavailable. Please upload your file again.');
    var length=Number(r.headers.get('content-length'));if(length>25*1024*1024)throw new Error('The original file is too large.');
    var reader=r.body.getReader(),parts=[],size=0;
    while(true){var chunk=await reader.read();if(chunk.done)break;size+=chunk.value.byteLength;
      if(size>25*1024*1024){await reader.cancel();throw new Error('The original file is too large.');}parts.push(chunk.value);}
    var name=design.properties.find(p=>p.name==='Artwork File')?.value||'saved-artwork';
    design.file=new File(parts,name,{type:r.headers.get('content-type')||'application/octet-stream'});
    return design;
  }
  function options(root,design,tileClass){
    var values=Object.fromEntries(design.properties.map(p=>[p.name,p.value]));
    var handled=new Set(['_Artwork URL','_Print File URL','_Preview URL','Artwork File','Project ID','_Project ID','Print Type','Design Notes','_Groots Builder']);
    root.querySelectorAll('[data-gw-prop]').forEach(function(group){
      var saved=values[group.dataset.gwProp];if(saved==null)return;
      var buttons=[...group.querySelectorAll('.'+tileClass)];if(!buttons.some(b=>b.dataset.val===saved))return;
      handled.add(group.dataset.gwProp);
      buttons.forEach(b=>b.classList.toggle('on',b.dataset.val===saved));
    });
    var notes=root.querySelector('[data-gw-notes]');if(notes)notes.value=values['Design Notes']||'';
    root.querySelector('[data-gw-qty]').value=Math.max(1,Math.min(9999,Number(design.quantity)||1));
    var extras=Object.fromEntries(design.properties.filter(p=>!handled.has(p.name)).map(p=>[p.name,p.value]));
    var visible=Object.entries(extras).filter(([name])=>!name.startsWith('_'));
    if(visible.length){var summary=document.createElement('p');summary.textContent='Saved options: '+visible.map(([name,value])=>name+': '+value).join(' · ');
      root.querySelector('[data-gw-status]').after(summary);}
    return extras;
  }
  function lock(root,value){
    root.inert=value;
    root.setAttribute('aria-busy',String(value));
  }
  function saved(status){
    status.textContent='Saved to your designs. ';
    var a=document.createElement('a');a.href=prefix+'dashboard#designs';
    a.textContent='View your designs';status.appendChild(a);
  }
  global.GrootsLibraryBridge={load:load,options:options,request:request,signIn:signIn,lock:lock,saved:saved};
})(window);
